module.exports = __webpack_public_path__ + "bc21bbe0ae79a9b176efddf16f669813.pdf";